/* KPC Meta Pixel ecommerce events — fires on storefront pages.
   ViewContent (PDP load), AddToCart (cart pubsub), InitiateCheckout (button click).
   Purchase is handled by a separate Shopify Customer Events Pixel — see
   analytics/docs/meta-purchase-pixel.js. Pixel must be installed in
   Shopify admin → Settings → Customer events. fbq() in theme.liquid does
   NOT load on /checkouts/*.

   Requires fbq() to be initialized in theme.liquid (line 49-60, pixel 1503394111130510).
   Hooks Dawn pubsub system: subscribe(PUB_SUB_EVENTS.cartUpdate, ...).

   Guard with window.__kpcMetaBound to prevent double-binding. */

(function () {
  if (window.__kpcMetaBound) return;
  window.__kpcMetaBound = true;

  function getCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }

  function track(event, properties) {
    if (typeof window.fbq !== 'function') return;
    try {
      window.fbq('track', event, properties || {});
    } catch (e) {
      /* swallow — never break the page on analytics failure */
    }
  }

  /* ViewContent — fires on PDP load. Theme injects window.kpcMetaProductData
     inline from main-product.liquid (productId, variantId, title, price).
     If unset, current page is not a product page — skip. */
  function fireViewContent() {
    var p = window.kpcMetaProductData;
    if (!p || !p.contentId) return;
    track('ViewContent', {
      content_ids: [String(p.contentId)],
      content_type: 'product',
      content_name: p.title || '',
      value: p.price != null ? Number(p.price) : undefined,
      currency: p.currency || getCurrency(),
    });
  }

  /* AddToCart — Dawn cartUpdate pubsub. Multiple sources can publish:
     - 'product-form'  : PDP add button (primary conversion intent)
     - 'quick-add'     : collection grid quick-add modal (also conversion intent)
     - 'cart-items'    : cart-page qty change (NOT first-add — same buyer adjusting)
     - 'cart-drawer'   : drawer qty change (same as above)
     The hook below filters which sources count as AddToCart. See TODO(human). */
  function bindCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') {
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      var src = payload && payload.source;
      if (!shouldFireAddToCart(src, payload)) return;

      var contentId = payload.productVariantId
        || (payload.cartData && payload.cartData.variant_id)
        || (payload.variantId)
        || null;
      if (!contentId) return;

      var cd = payload.cartData || {};
      var item = (cd.items && cd.items[0]) || cd;
      var price =
        item.final_price != null ? Number(item.final_price) / 100 :
        item.price != null ? Number(item.price) / 100 :
        undefined;

      track('AddToCart', {
        content_ids: [String(contentId)],
        content_type: 'product',
        content_name: item.product_title || item.title || '',
        value: price,
        currency: getCurrency(),
      });
    });
  }

  /* Strict policy: only fresh-add events count as AddToCart.
     Cart qty increments (cart-items, cart-drawer) are excluded to keep the
     Meta funnel ratio readable. Revisit after 1-2 months of data — if
     lookalike learning is slow, broaden to include qty-up events. */
  function shouldFireAddToCart(source, payload) {
    return source === 'product-form' || source === 'quick-add';
  }

  /* InitiateCheckout — any click on a checkout button. Dawn renders
     `<button name="checkout">` in main-cart-footer and cart-drawer.
     Capture phase so we fire before form submit / navigation. */
  function bindCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!btn) return;
      var snap = window.kpcCartSnapshot || null;
      track('InitiateCheckout', {
        content_type: 'product',
        num_items: snap && snap.item_count != null ? snap.item_count : undefined,
        value: snap && snap.total_price != null ? Number(snap.total_price) / 100 : undefined,
        currency: getCurrency(),
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fireViewContent();
      bindCartUpdates();
      bindCheckout();
    });
  } else {
    fireViewContent();
    bindCartUpdates();
    bindCheckout();
  }
})();
